export const normalizeRoutePath = (pathname?: string) => {
  if (!pathname) {
    return '/';
  }
  const trimmed = pathname.trim();
  if (!trimmed || trimmed === '/') {
    return '/';
  }
  return trimmed.replace(/\/+$/, '') || '/';
};

export const isSameRoutePath = (left?: string, right?: string) =>
  normalizeRoutePath(left) === normalizeRoutePath(right);
